import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-op-manage-columns",
  "use": "icon-op-manage-columns-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-op-manage-columns\"><path d=\"M13 2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M3 13a1 1 0 0 1-1-1V6h3.333v7zm3.333-7h3.334v7H6.333zM14 12a1 1 0 0 1-1 1h-2.333V6H14zm0-7H2V4c0-.551.448-1 1-1h10c.552 0 1 .449 1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol